import { Channel } from "stream-chat";
import { DefaultStreamChatGenerics } from "stream-chat-react/dist/types/types";

export type ChatStatusPicks = {
  isUnreadOnly: boolean;
  isPendingActionOnly: boolean;
};

const hasUnread = (channel: Channel<DefaultStreamChatGenerics>) =>
  channel.countUnread() > 0;

const hasPendingActions = (channel: Channel<DefaultStreamChatGenerics>) =>
  ((channel.data?.pending_action_items_count as number) || 0) > 0;

export const matchesChatFilters = (
  channel: Channel<DefaultStreamChatGenerics>,
  { isUnreadOnly, isPendingActionOnly }: ChatStatusPicks
): boolean => {
  if (isUnreadOnly && isPendingActionOnly) {
    return hasUnread(channel) || hasPendingActions(channel);
  }

  if (isUnreadOnly) {
    return hasUnread(channel);
  }

  if (isPendingActionOnly) {
    return hasPendingActions(channel);
  }

  return true;
};
